import ModalContext from "../context/modalContext";

const ModalConsumer = ModalContext.Consumer;

export default ModalConsumer;